module.exports = __webpack_public_path__ + "files/a31576e288be18b8b3d8dba661ff83ed.png";